import { useState } from 'react';

import logoPlaceholder from 'assets/company-avatar-placeholder.png';

import { getPublicLogoUrl } from 'api/publicApi';
import { Backend } from 'api/endpoints';
import { getFile } from 'api/fileApi';

const useCompanyLogo = (
	offerId: string,
	logo?: Backend.File,
	isPublic?: boolean,
) => {
	const [companyLogo, setLogo] = useState(getFile(logo) ?? logoPlaceholder);
	if (isPublic && logo) {
		getPublicLogoUrl(offerId).then(logo =>
			logo ? setLogo(logo) : logoPlaceholder,
		);
	}

	return companyLogo;
};

export default useCompanyLogo;
